<template>
	<hr class="my-1 dark:border-gray-800">
</template>
<script setup lang="ts"></script>